export default __webpack_public_path__ + "static/camera_b.09e07a6941384e53b2951a7453d279b8.svg";